import { useQuery, keepPreviousData } from '@tanstack/react-query';

import api from 'src/api';
import useUserStore from 'src/hooks/stores/useUserStore';

const getFeatureFlags = (email) => api.get('featureflag', {
  params: {
    email: email || '',
  },
  //Ta dando problema no backend, vamos usar query params por enquanto
  // headers: {
  //   'X-User-Email': email || '',
  // },
}).then(res => res.data);

export const useFeatureFlagsQuery = (options = {}) => {
  const email = useUserStore((state) => state.email);
  
  return useQuery({
    queryKey: ['featureflag', email],
    queryFn: () => getFeatureFlags(email),
    staleTime: Infinity,
    placeholderData: keepPreviousData,
    enabled: options.enabled ?? true,
  });
};
